
import React, { useRef, useEffect, useState } from 'react';
import videoExplain from '../../Assets/img/PRESSING_360.mp4'
import { Link } from 'react-router-dom';


const Hero = () => {
    const videoRef = useRef(null);
    const [isInView, setIsInView] = useState(false);


    useEffect(() => {
        const handleScroll = () => { 
            if (videoRef.current) {
                const videoPosition = videoRef.current.getBoundingClientRect();
                const windowHeight = window.innerHeight;

                // Vérifie si la vidéo est au centre de l'écran
                const isVideoInMiddle =
                    videoPosition.top + videoPosition.height / 2 >= windowHeight / 2 - 100 &&
                    videoPosition.top + videoPosition.height / 2 <= windowHeight / 2 + 100;

                setIsInView(isVideoInMiddle);
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Nettoyage 
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
 

    const handleScrollToSection = (sectionId) => {
        // Effectuer le défilement vers la section
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: "smooth", block: "start" });

            // Mettre à jour l'URL sans afficher le hachage
            window.history.pushState(null, "", window.location.pathname);
        }
    };

    return (
        <section className="main-hero">
            <h1>Une solution complète pour votre pressing, simple et efficace.</h1>
            <p className='description'>Suivez vos commandes, fidélisez vos clients et optimisez vos opérations, le tout en un seul clic.</p>
            <div className='buttons'>
                <button onClick={() => handleScrollToSection("explanatoryvideo")} className="btn  btn-danger text-white ">
                    <i className="fa-brands fa-youtube"></i> Vidéo Explicative
                </button>
                <Link to={`https://wa.me/2250788898998?text=Bonjour Elk-Tech Groupe, est-ce qu'il serait possible de discuter avec quelqu'un au sujet du logiciel Pressing 360? `} className="btn secondary">
                    <i className="fa-brands fa-whatsapp"></i> Parler à un commercial
                </Link>
            </div>

            <div className="video-container">
                <video ref={videoRef}
                    autoPlay
                    loop
                    muted
                    playsInline
                    className={`background-video ${isInView ? 'large' : 'small'}`}>
                    {/* <source src="/media/cc0-videos/flower.webm" type="video/webm" /> */}
                    <source src={videoExplain} type="video/mp4" />

                </video>
            </div>

        </section>
    )
}

export default Hero